import React, {ReactElement} from 'react'

export type HeaderItems<T> = Array<HeaderItem<keyof T>>

export enum TableHeaderAction {
    filter,
    sorting,
    filterSidePage
}

export interface FilterOption {
    label: React.ReactNode
    value: string
}

export interface TableHeaderItem<T = string> {
    label?: React.ReactNode
    dataLabel: string
    paramKey: T
    paramKeys?: Array<T>
    type?: TableHeaderAction
    disabled?: boolean
    width?: string
    renderer?: (data: any, expandingRowRef?: HTMLDivElement) => ReactElement | string
}

export interface TableHeaderFilterProps<T = string> extends TableHeaderItem<T> {
    type?: TableHeaderAction.filter
    filterOptions: FilterOption[]
}

export interface TableHeaderSortingProps<T = string> extends TableHeaderItem<T> {
    type?: TableHeaderAction.sorting
}

export interface TableHeaderSidePageFilterProps<T = string> extends TableHeaderItem<T> {
    type?: TableHeaderAction.filterSidePage
    sidePagePath: string
}

export type HeaderItem<T = string> = TableHeaderSortingProps<T> | TableHeaderFilterProps<T> | TableHeaderSidePageFilterProps<T>
